import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const TIMEOUT = 1000 * 60 * 30;    // 30 min

export function useIdleLogout({ onLogout, enabled = true } = {}) {
  useEffect(() => {
    if (!enabled) return;          // ⬅️  NO activo todavía


    const doLogout = async () => {
             try { await onLogout(); } catch {}
             try { await api.post('/clientes/logout'); } catch {}
            };




let timer = setTimeout(doLogout, TIMEOUT);

    const reset = () => {
    clearTimeout(timer); timer = setTimeout(doLogout, TIMEOUT);

    };

    window.addEventListener('mousemove', reset);
    window.addEventListener('keydown',   reset);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('mousemove', reset);
      window.removeEventListener('keydown',   reset);
    };
  }, [enabled, onLogout]);
}